import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { Property } from 'types/onboarding'

interface UseSelectPackagesProps {
  setProperty: Dispatch<SetStateAction<Property | undefined>>
  property: Property
}
export const useSelectPackagesForOne = ({
  setProperty,
  property,
}: UseSelectPackagesProps) => {
  const [modalVisible, setModalVisible] = useState(false)

  const [activeProperty, setActiveProperty] = useState<string | null>(null)

  const selectProduct = (productId: string) => {
    setProperty({ ...property, product: productId })
    setModalVisible(false)
    setActiveProperty(null)
  }

  const findProduct = (propertyId: string | null) => {
    if (!propertyId) return undefined
    return property?.product
  }

  useEffect(() => {
    if (activeProperty) {
      setModalVisible(true)
    }
  }, [activeProperty])

  return {
    modalVisible,
    setModalVisible,
    activeProperty,
    setActiveProperty,
    selectProduct,
    findProduct,
  }
}
